import { useState, useEffect } from 'react';
import { isFeatureEnabled } from '../services/analyticsService';

const FLAG = 'lufa-deals';

export function useLufaDealsEnabled(): boolean {
  const [enabled, setEnabled] = useState(() => isFeatureEnabled(FLAG));

  useEffect(() => {
    // PostHog loads flags async after init; re-evaluate after a short delay
    const timer = setTimeout(() => setEnabled(isFeatureEnabled(FLAG)), 2000);
    return () => clearTimeout(timer);
  }, []);

  return enabled;
}
